import React, { useState } from 'react';
import Input from '../Input';
import CloseCircle from '../Icons/CloseCircle';
import SearchIcon from '../Icons/SearchIcon';

export interface FilterSearchNewCarProps {
  onSearchValueChange?: (value: string) => void;
  containerClassName?: string;
  inputClassName?: string;
}

export default function FilterSearchNewCar({
  onSearchValueChange = () => {},
  containerClassName = '',
  inputClassName = '',
}: FilterSearchNewCarProps) {
  const [inputValues, setInputValues] = useState('');
  const handleChange = (e: any) => {
    const newValue = e.target.value;
    onSearchValueChange(newValue);
    setInputValues(newValue);
  };
  const handleOnClickRemoveSearch = () => {
    setInputValues('');
  };
  return (
    <Input
      id="dd-search-navbar"
      type="text"
      placeholder={'Cari jenis mobil atau tipe mobil'}
      style={{ fontSize: '12px', fontStyle: 'italic' }}
      icon={inputValues ? <CloseCircle size={20} /> : <SearchIcon fill="#4F4C4D" size={20} />}
      iconPosition="left"
      iconClassName="!border-reliableBlack20 md:pr-0 lg:pr-0"
      labelClassName="text-reliableBlack70 font-semibold"
      onChange={handleChange}
      inputClassName={`placeholder:!text-reliableBlack30 !px-2 !py-3 h-auto !max-h-none !border-reliableBlack20 lg:!px-2 placeholder:text-[15px] ${inputClassName}`}
      inputBackground={'bg-white'}
      value={inputValues}
      containerClassName={`${containerClassName}`}
      handleOnClickIcon={inputValues ? handleOnClickRemoveSearch : null}
    />
  );
}
